import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationDefaultIsShowRoomPriceInCalender = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { isShowRoomPriceInCalender } = viewModel;

	const isEdited = isShowRoomPriceInCalender.isEdited;
	const hasError = Boolean(isShowRoomPriceInCalender.error);

	const onSetIsShowRoomPriceInCalender = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isShowRoomPriceInCalender",
					value: {
						...isShowRoomPriceInCalender,
						value: input,
					},
				},
			]);
		},
		[isShowRoomPriceInCalender, onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		isShowRoomPriceInCalender,
		onSetIsShowRoomPriceInCalender,
	};
};
